import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustStrip from "./components/TrustStrip";
import DeviceWorld from "./components/DeviceWorld";
import CategoryShowcase from "./components/CategoryShowcase";
import ProductShowcase from "./components/ProductShowcase";
import ProductDetail from "./components/ProductDetail";
import AccessoriesSection from "./components/AccessoriesSection";
import EverydayTech from "./components/EverydayTech";
import MarketStall from "./components/MarketStall";
import WhyFist from "./components/WhyFist";
import FaqSection from "./components/FaqSection";
import LocationSection from "./components/LocationSection";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import MobileCTA from "./components/MobileCTA";
import type { TechProduct } from "@/mocks/techData";

export default function Home() {
  const [selected, setSelected] = useState<TechProduct | null>(null);

  return (
    <div className="bg-background-50">
      <Navbar />

      <main className="pb-16 md:pb-0">
        <Hero />
        <TrustStrip />
        <DeviceWorld />
        <CategoryShowcase />
        <ProductShowcase onOpen={setSelected} />
        <AccessoriesSection />
        <EverydayTech />
        <MarketStall />
        <WhyFist />
        <FaqSection />
        <LocationSection />
        <FinalCTA />
      </main>

      <Footer />
      <MobileCTA />

      {selected && <ProductDetail product={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}